import { render, staticRenderFns } from "./bulletin_board.vue?vue&type=template&id=550922f0"
import script from "./bulletin_board.vue?vue&type=script&lang=js"
export * from "./bulletin_board.vue?vue&type=script&lang=js"
import style0 from "./bulletin_board.vue?vue&type=style&index=0&id=550922f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports